'use client';

import { preconnect } from 'react-dom';

/**
 * Warms the connection to Supabase while the page's HTML and JavaScript load (PP-144), so the
 * first database calls from the browser skip DNS, TCP and TLS setup. React hoists the hint into
 * <head>, during server render where the shell renders on the server. supabase-js fetches without
 * credentials, so the hint is crossorigin="anonymous"; without it the browser warms a connection
 * from the credentialed pool that nothing uses. Rendered by AppShell on every route except public
 * marketing pages, which never call Supabase from the browser.
 */
export default function SupabasePreconnect() {
  // Read at render, literally, so Next inlines the value into the client bundle.
  const configured = process.env.NEXT_PUBLIC_SUPABASE_URL;
  if (!configured) return null;
  let origin: string;
  try {
    origin = new URL(configured).origin;
  } catch {
    return null;
  }
  preconnect(origin, { crossOrigin: 'anonymous' });
  return null;
}
